<template>
  <div class="right side col-sm-2 col-xs-12">
    <div class="my_name_side">
      <div class="my_name_side_img">
        <ACCOUNT />
      </div>
      <div class="my_name_side_tx">היי, {{ user.firstname }}</div>
    </div>
    <div class="cashback" v-if="cashback.options.enabled">
      <router-link :to="{name: 'cashback'}" class="cashback-title">
        <Cashback/>
        כרמלה קאשבק
      </router-link>
      <div class="cashback-message">
        <div v-if="cashback.points">
          <div>צברת {{ cashback.points }} נקודות</div>
          <div><strong>ששוות {{ pointsWorth }} ₪</strong></div>
        </div>
      </div>
    </div>
    <div class="side_nav">
      <div
        class="side_nav_link ease"
        v-bind:class="{ active: this.$route.name  === 'myaccount' || this.$route.name == 'userhome' }"
      >
        <router-link :to="{name: 'myaccount'}">החשבון שלי</router-link>

      </div>
      <div
        class="side_nav_link ease"
        v-bind:class="{ active: this.$route.name === 'history' }"
      >
        <router-link :to="{name: 'history'}">
          היסטורית הזמנות
        </router-link>

      </div>
      <div
        class="side_nav_link ease"
        v-bind:class="{ active: this.$route.name === 'favorites' }"
      >
        <router-link :to="{name: 'favorites'}">
          המועדפים שלי
        </router-link>

      </div>
      <div
        class="side_nav_link ease"
        v-bind:class="{ active: this.$route.name === 'permenent' }"
      >
        <router-link :to="{name: 'permenent'}">
          הזמנה קבועה
        </router-link>

      </div>
      <div
        class="side_nav_link ease"
        v-bind:class="{ active: this.state === 'logout' }"
      >
        <a
          href="#"
          @click.prevent="logOut"
        >{{getLogoutText}}</a>
      </div>
    </div>
  </div>
</template>
<script>
  /** SVG imports */
  import ACCOUNT from "../../assets/img/account.svg";
  import Cashback from "../../assets/img/cashback.svg";
  import {mapGetters} from "vuex";

  export default {
    props: ["state"],
    data() {
      return {
        cashback: this.$store.state.cashback
      };
    },
    methods: {
      sideNav(data) {
        this.$emit("clicked", data);
      },
      logOut() {
        this.$store.dispatch("userLogout");
      }
    },
    computed: {
      ...mapGetters([{pointsWorth: "getCashbackPointsWorth"}, "getLogoutText"]),
      user() {
        return this.$store.state.userLoggedInfo;
      }
    },
    components: {
      ACCOUNT,
      Cashback
    }
  };
</script>
<style lang="sass" scoped>
.cashback
  margin-bottom: 1em
  padding: 5px 15px
  border: 0 dashed #1e824c
  border-width: 1px 0
  .cashback-title
    color: #1e824c
    font-weight: 900
    display: flex
    align-items: center
    column-gap: 5px
    margin: 0 -7px 0 0
    svg
      fill: #1e824c
      margin-bottom: 4px
  .cashback-message
    padding-right: 30px
    > div
</style>